export enum AddExistingMedicineFieldLabel {
  MedicineOrHealthSupplement = "Naziv lijeka/dodatka prehrani",
  IntakeRegime = "Režim doziranja",
  IntakePartOfDay = "Doba dana uzimanja",
}
